export default __webpack_public_path__ + "static/media/left.874e573b.svg";